export const createChatSessionConfigSnapshot = (
  segmentCode,
  config = {},
  apiWelcome
) => ({
  segmentCode: segmentCode || '',
  welcome: apiWelcome === undefined ? config.welcome || '' : apiWelcome || '',
  top_question_config: JSON.parse(
    JSON.stringify(
      config.top_question_config || {
        is_top_question: false,
        top_question_list: []
      }
    )
  )
});

export const resolveLiveTopQuestionConfig = (config = {}) => {
  const topQuestionConfig = config.top_question_config;
  return {
    is_top_question: topQuestionConfig?.is_top_question ?? false,
    top_question_list: Array.isArray(topQuestionConfig?.top_question_list)
      ? topQuestionConfig.top_question_list
      : []
  };
};
